import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import zhtw from "./locales/zh-tw.json";
import zhcn from "./locales/zh-cn.json";

const i18n = createI18n({
  legacy: false,
  locale: import.meta.env.VITE_APP_THEME == "DNA" ? "en" : "zh-cn",
  fallbackLocale: "en",
  messages: {
    en,
    "zh-tw": zhtw,
    "zh-cn": zhcn,
  },
});

export default i18n;
